var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { configure } from "mobx";
import { O } from "vwebapp-framework";
import { ignore } from "mobx-sync";
import { setUseProxies, setAutoFreeze } from "immer";
import { MainState } from "./main";
// configure({ enforceActions: 'always' });
configure({ enforceActions: "observed" });
// fixes various issues when Immer is sent mobx objects (see NPMPatches.ts for old fix attempts)
setUseProxies(false);
setAutoFreeze(false);
export class RootState {
    constructor() {
        // [immerable] = true; // makes the store able to be used in immer's "produce" function
        this.main = new MainState();
        // @O @ignore vMenu: VMenuState;
    }
}
__decorate([
    O
], RootState.prototype, "main", void 0);
__decorate([
    O.ref
], RootState.prototype, "feedback", void 0);
__decorate([
    O, ignore
], RootState.prototype, "firelink", void 0);
export const store = new RootState();
G({ store });
